import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
import { PillType } from "./attributes.js";
const determinePillType = (props) => {
  if (props.type) return props.type;
  const priorityType = [
    { check: props.danger, type: PillType.Danger },
    { check: props.warning || props.warn, type: PillType.Warning },
    { check: props.success, type: PillType.Success },
    { check: props.info || props.information, type: PillType.Info },
    { check: props.neutral, type: PillType.Neutral }
  ].find(({ check }) => check);
  return priorityType?.type ?? PillType.Neutral;
};
const guidePillHtml = async (props) => {
  const type = determinePillType(props);
  const classNames = [EditorClasses.Pill, `pill__${type}`, props.class].filter(
    Boolean
  );
  return html`
    <span class="${classNames.join(" ")}">
      <ssg-children></ssg-children>
    </span>
  `;
};
export {
  determinePillType,
  guidePillHtml
};
//# sourceMappingURL=component.js.map
